import styled from 'styled-components';

export const Amount = styled.h1`
    color: #1a1f36;
}
`;

export const Date = styled.span`
    color: #767777;
    font-weight: 350;
}
`;
